import React from 'react';
import '../styles/TopBar.css';

const TopBar = () => {
  return (
    <div className="topbar">
      <div className="topbar-container">
        <div className="topbar-left">
          <span className="topbar-item">
            <a href="mailto:info@taxi-24hrs.co.uk">info@taxi-24hrs.co.uk</a>
          </span>
        </div>
        <div className="topbar-right">
          <span className="topbar-item">
            <a href="tel:02038393300">+44 203 839 3300</a>
          </span>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
